import Image from "next/image";
import React from "react";
import styles from "../../../../styles/BannerImages.module.css";

interface BannerImagesProps {
  pageName: string;
  onClick?: () => void;
}

const BannerImages: React.FC<BannerImagesProps> = ({ pageName, onClick }) => {
  const desktopImages = [
    "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/desktop_banner_new1npng.webp",
    pageName === "CPA"
      ? "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/desktop_banner_new2.webp"
      : "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/desktop_banner.webp",
    "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/desktop_banner_new3.webp",
  ];

  const mobileImages = [
    "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/mobile_banner_new1n.webp?tr=w-385,h-140,q-80",
    pageName === "CPA"
      ? "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/mobile_banner_new2.webp?tr=w-385,h-140,q-80"
      : "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/mobile_banner_cma.webp?tr=w-385,h-140,q-80",
    "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/mobile_banner_new3.webp?tr=w-385,h-140,q-80",
  ];

  const getAnimationClass = (index: number): string => {
    switch (index) {
      case 0:
        return styles.bannerImage1;
      case 1:
        return styles.bannerImage2;
      case 2:
        return styles.bannerImage3;
      default:
        return "";
    }
  };

  return (
    <div
      className={`relative w-full h-[135px] lg:h-[145px] ${onClick ? "cursor-pointer" : ""}`}
      onClick={onClick}
    >
      <div className="hidden md:block">
        {desktopImages.map((src, index) => (
          <div
            key={`desktop-${index}`}
            className={`absolute inset-0 ${getAnimationClass(index)}`}
          >
            <Image
              src={src}
              alt={`Banner ${index + 1}`}
              fill
              className="object-fill"
              priority={index === 0}
              loading={index === 0 ? "eager" : "lazy"}
            />
          </div>
        ))}
      </div>

      <div className="md:hidden">
        {mobileImages.map((src, index) => (
          <div
            key={`mobile-${index}`}
            className={`absolute inset-0 ${getAnimationClass(index)}`}
          >
            <Image
              src={src}
              alt={`Banner ${index + 1}`}
              fill
              className="object-fill"
              priority={index === 0}
              loading={index === 0 ? "eager" : "lazy"}
              sizes="(max-width: 767px) 100vw, 0px"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BannerImages;
